import React from 'react';
export var Suspense = function (_a) {
    var children = _a.children, condition = _a.condition, fallback = _a.fallback;
    return condition ? React.createElement(React.Fragment, null, children) : React.createElement(React.Fragment, null, fallback);
};
